<template>
  <div
    ref="kt_modal_faturamento_editar_medicamento"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_medicamento"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Medicamento</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Nº do lote</label>
              <input
                type="text"
                id="txtnLote"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nLote'] ? 'is-invalid' : '',
                ]"
                v-model="this.refMed.nLote"
                maxlength="20"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nLote"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Quantidade</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                style="text-align: right"
                v-model="this.refMed.qLote"
                :class="[
                  'form-control mb-2',
                  errosValidacao['qLote'] ? 'is-invalid' : '',
                ]"
                :options="optionsQtd"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["qLote"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Data de Fabricação</label>
              <el-date-picker
                id="dtpFabricacao"
                v-model="this.refMed.dFab"
                type="datetime"
                name="dtpFabricacao"
                placeholder="Selecione uma data"
                class="w-100"
                format="DD/MM/YYYY"
                size="large"
                @keydown.stop.prevent.enter=""
                :class="{ 'is-invalid': errosValidacao.dFab }"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["dFab"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Data de Validade</label>
              <el-date-picker
                id="dtpValidade"
                v-model="this.refMed.dVal"
                type="datetime"
                name="dtpValidade"
                placeholder="Selecione uma data"
                class="w-100"
                format="DD/MM/YYYY"
                size="large"
                @keydown.stop.prevent.enter=""
                :class="{ 'is-invalid': errosValidacao.dVal }"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["dVal"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Preço máximo consumidor</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                style="text-align: right"
                v-model="this.refMed.vPMC"
                :class="[
                  'form-control mb-2',
                  errosValidacao['vPMC'] ? 'is-invalid' : '',
                ]"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["vPMC"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";

const refMedInicializado = {
  nLote: "",
  qLote: 0,
  dFab: "",
  dVal: "",
  vPMC: 0,
};

export default {
  components: { CurrencyInput },
  emits: [
    "exibirModalEditarMedicamento",
    "adicionarMedicamento",
    "editarMedicamento",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refMedFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarMedicamento", this.refMed);
        } else {
          this.$emit("editarMedicamento", this.refMed, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_medicamento);
        this.$emit("exibirModalEditarMedicamento", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      }
    },
    validar() {
      let result = true;

      if (!this.refMed.nLote) {
        this.errosValidacao.nLote = "Informe o Número do Lote";
        result = false;
      } else if (this.refMed.nLote.trim().length <= 0) {
        this.errosValidacao.nLote = "Informe o Número do Lote";
        result = false;
      }

      if (!this.refMed.qLote) {
        this.errosValidacao.qLote = "Informe a Quantidade do Lote";
        result = false;
      } else if (isNaN(this.refMed.qLote)) {
        this.errosValidacao.qLote =
          "A Quantidade do Lote deve ser um número válido";
        result = false;
      }

      if (!this.refMed.dFab) {
        this.errosValidacao.dFab = "Informe a Data de Fabricação";
        result = false;
      } else if (!this.isValidDate(this.refMed.dFab)) {
        this.errosValidacao.dFab = "Informe uma Data de Fabricação válida";
        result = false;
      }

      if (!this.refMed.dVal) {
        this.errosValidacao.dVal = "Informe a Data de Validade";
        result = false;
      } else if (!this.isValidDate(this.refMed.dVal)) {
        this.errosValidacao.dVal = "Informe uma Data de Validade válida";
        result = false;
      }

      if (!this.refMed.vPMC) {
        this.errosValidacao.vPMC = "Informe o Preço Máximo ao Consumidor";
        result = false;
      } else if (isNaN(this.refMed.vPMC)) {
        this.errosValidacao.vPMC =
          "O Preço Máximo ao Consumidor deve ser um número válido";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_medicamento);
      this.$emit("exibirModalEditarMedicamento", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    isValidDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(Date.parse(date))) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refMed = JSON.parse(JSON.stringify(this.refMedFaturamento));
    } else {
      this.refMed = JSON.parse(JSON.stringify(refMedInicializado));
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txtnLote");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refMed: JSON.parse(JSON.stringify(refMedInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
      optionsQtd: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 3,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style></style>
